module.exports = __webpack_public_path__ + "resources/img/solution_finance_cloud2_m_v2.d47179773c6513e868a04b4613c2a691.png";